import React from 'react'
import { Button } from '../../atoms'
import useTrans from '../../../hooks/useTrans'
import { getAltText } from '../../../utils/safe'

const TeamCard = ({
  id,
  img,
  title,
  description,
  tel,
  email,
  setReparto,
  selectedId,
  mostraPersone,
}) => {
  const t = useTrans()
  const handleClick = () => {
    selectedId === id ? setReparto(null) : setReparto(id)
  }

  return (
    <div className="team_container">
      <div className="team_container__card">
        <img className="team_container__card__image" src={img?.url} alt={getAltText(img)}/>
        <div className="team_container__card__description">
          <strong>{title}</strong>
          <p>{description}</p>
        </div>
        <div className="team_container__card__contact">
          <div className="team_container__card__contact__container">
            <p className="team_container__card__contact__container__titolo">{t('Telefono')}</p>
            <p>{tel}</p>
          </div>
          <div className="team_container__card__contact__container">
            <p className="team_container__card__contact__container__titolo">E-mail</p>
            <p>{email}</p>
          </div>
        </div>
      </div>
      {mostraPersone && (
        <div className="contatti_template__buttons__container">
          <Button
            disabled={false}
            label={selectedId === id ? t('Nascondi Persone') : t('Mostra Persone')}
            variant="primary"
            size="medium"
            type="submit"
            onClick={() => {
              handleClick()
            }}
          />
        </div>
      )}
    </div>
  )
}

export default TeamCard
